import { wixAxios } from '../../utils/wix-axios';

export const getUserProStatus = async (): Promise<boolean> => {
  return wixAxios
    .get(`/_api/experts-server/v1/experts/`)
    .then(response => {
      let expTypes = response.data.expertTypes;
      return expTypes && expTypes.types && (expTypes.types.includes('pro') || expTypes.types.includes('site_builder' ));
    });
};
